import { motion } from "framer-motion";
import "./BrandIdentityBoardSection.css";

const BRAND_BOARD_IMAGE = "/brand/brand-identity-board.png";
const BOARD_WIDTH = 1024;
/** Visible height — bottom caption row (명함 디자인 …) cropped via CSS */
const BOARD_HEIGHT = 645;

export default function BrandIdentityBoardSection() {
  return (
    <section
      id="brand-board"
      data-testid="brand-identity-board-section"
      className="ds-brand-board"
      aria-label="브랜드 아이덴티티 보드"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="ds-brand-board__frame"
      >
        <img
          src={BRAND_BOARD_IMAGE}
          width={BOARD_WIDTH}
          height={BOARD_HEIGHT}
          alt="DSITESOLUTION 브랜드 아이덴티티 보드"
          className="ds-brand-board__image"
          loading="lazy"
          decoding="async"
          draggable={false}
        />
      </motion.div>
    </section>
  );
}
